module.exports = __webpack_public_path__ + "assets/06b2c67d765b91f7808ad4612be82099.mp3";